import PropTypes from "prop-types";

import WarningIcon from "assets/svg/warning.svg";

import Button from "components/common/button";

import styles from "./styles.module.css";

const PassiveAccountReasonModal = ({ message, closeModal }) => (
  <div className={styles.wrapper}>
    <div className={styles.icon}>
      <WarningIcon />
    </div>
    <p className={styles.title}>Hesabın Askıya Alındı</p>
    <p className={styles.description}>{message.tr}</p>
    <div className={styles.useDifferentAccountButton}>
      <Button onClick={closeModal} buttonClass={styles.buttonClass} outline size="M">
        Farklı Bir Hesapla Giriş Yap
      </Button>
    </div>
  </div>
);

PassiveAccountReasonModal.propTypes = {
  message: PropTypes.string,
  closeModal: PropTypes.func,
};

export default PassiveAccountReasonModal;
